import { ReactElement } from "react";

import { adminAccount } from "../pages/Accounts/Admin";
import { storeAccount } from "../pages/Accounts/Store";
import { clubAccount } from "../pages/Accounts/Club";
import { agentAccount } from "../pages/Accounts/Agents";
import { academyAccount } from "../pages/Accounts/Academy";
import { coachAccount } from "../pages/Accounts/Coach";
import { UserRole } from "../types/user.types";
import { gymAccount } from "../pages/Accounts/Gym";
import { EntertainmentAccount } from "../pages/Accounts/Entertainment";

export const getCurrentAccountResources = (role: UserRole) => {
  let customRoutes: ReactElement[];
  let resources: ReactElement[];
  let dashboard: any;

  switch (role) {
    case UserRole.admin:
      customRoutes = adminAccount.customRoutes;
      resources = adminAccount.resources;
      dashboard = adminAccount.dashboard;
      break;
    case UserRole.sportClub:
      customRoutes = clubAccount.customRoutes;
      resources = clubAccount.resources;
      dashboard = clubAccount.dashboard;
      break;
    case UserRole.store:
      customRoutes = storeAccount.customRoutes;
      resources = storeAccount.resources;
      dashboard = storeAccount.dashboard;
      break;
    case UserRole.agent:
      customRoutes = agentAccount.customRoutes;
      resources = agentAccount.resources;
      dashboard = agentAccount.dashboard;
      break;
    case UserRole.gym:
      customRoutes = gymAccount.customRoutes;
      resources = gymAccount.resources;
      dashboard = gymAccount.dashboard;
      break;
    case UserRole.academy:
      customRoutes = academyAccount.customRoutes;
      resources = academyAccount.resources;
      dashboard = academyAccount.dashboard;
      break;
    case UserRole.coach:
      customRoutes = coachAccount.customRoutes;
      resources = coachAccount.resources;
      dashboard = coachAccount.dashboard;
      break;
    case UserRole.entertainment:
      customRoutes = EntertainmentAccount.customRoutes;
      resources = EntertainmentAccount.resources;
      dashboard = EntertainmentAccount.dashboard;
      break;
    case UserRole.unknown:
    default:
      customRoutes = [];
      resources = [];
      dashboard = "dashboard";
  }
  return {
    customRoutes,
    resources,
    dashboard,
  };
};
